<template>
  <div class="rounded-20 px-20 py-34 bg-white">
    <slot />
  </div>
</template>